import { render, staticRenderFns } from "./HistoryRevision.vue?vue&type=template&id=2e4bc9f2"
import script from "./HistoryRevision.vue?vue&type=script&lang=js"
export * from "./HistoryRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports